import { parseShippingCostNumber, buildShippingRow } from './quotePdfPayloadUtils';

function normalizeShippingMethod(raw) {
  const lower = String(raw || '').toLowerCase();
  if (lower.includes('premium') && lower.includes('air')) return 'Premium Air shipping';
  if (lower.includes('express') && lower.includes('air')) return 'Express Air shipping';
  if (lower.includes('regular') && lower.includes('air')) return 'Regular Air Shipping';
  if (lower.includes('express') && lower.includes('sea')) return 'Express Sea shipping';
  if (lower.includes('regular') && lower.includes('sea')) return 'Regular Sea Shipping';
  return raw || 'Shipping';
}

const SHIPPING_LINE_PATTERNS = [
  { method: 'Premium Air shipping', pattern: /premium\s+air[^\d$]*\$?\s*([\d,]+(?:\.\d+)?)/i },
  { method: 'Express Air shipping', pattern: /express\s+air[^\d$]*\$?\s*([\d,]+(?:\.\d+)?)/i },
  { method: 'Regular Air Shipping', pattern: /regular\s+air[^\d$]*\$?\s*([\d,]+(?:\.\d+)?)/i },
  { method: 'Express Sea shipping', pattern: /express\s+sea[^\d$]*\$?\s*([\d,]+(?:\.\d+)?)/i },
  { method: 'Regular Sea Shipping', pattern: /regular\s+sea[^\d$]*\$?\s*([\d,]+(?:\.\d+)?)/i },
];

/**
 * Parse Tier-1 shipping base prices from pasted text (no AI).
 * Returns one base cost per recognized shipping method.
 */
export function parseShippingBaseCostsFromText(text = '') {
  if (!text.trim()) return [];

  const found = [];
  SHIPPING_LINE_PATTERNS.forEach(({ method, pattern }) => {
    const match = text.match(pattern);
    if (!match) return;
    const cost = parseShippingCostNumber(match[1]);
    if (cost != null) found.push({ method, cost });
  });
  return found;
}

/** AI may return cost, baseCost, or costs[] — use Tier 1 only; ignore AI tier 2/3. */
export function extractBaseShippingCostFromAiRow(row = {}) {
  if (row.baseCost != null) return parseShippingCostNumber(row.baseCost);
  if (row.cost != null) return parseShippingCostNumber(row.cost);
  if (Array.isArray(row.costs) && row.costs.length) {
    return parseShippingCostNumber(row.costs[0]);
  }
  return null;
}

export function buildPdfShippingRows(sourceText, aiShippingRows = [], timeframes = {}, tierCount = 3) {
  const fromText = parseShippingBaseCostsFromText(sourceText);

  if (fromText.length) {
    return fromText.map(({ method, cost }) => buildShippingRow(
      method,
      cost,
      timeframes[method] || '',
      tierCount,
    ));
  }

  return (aiShippingRows || [])
    .map((row) => {
      const method = normalizeShippingMethod(row.method);
      const baseCost = extractBaseShippingCostFromAiRow(row);
      return buildShippingRow(method, baseCost, timeframes[method] || row.timeframe || '', tierCount);
    })
    .filter((row) => row.baseCost != null || row.method);
}
